import styled from "@emotion/styled";
const FileUpload = {
    Wrapper: styled.div `
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: 2em;
    margin-bottom: 1em;
    padding: 1em;
    border-radius: 0.25rem;
    background-color: ${({ theme }) => theme.color.badge};
    min-width: 0;
  `,
    TextWrapper: styled.div `
    display: flex;
    flex-direction: column;
    min-width: 0;
  `,
    FileName: styled.p `
    margin: 0 !important;
    font-size: 16px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
    FileExtension: styled.p `
    margin: 0 !important;
    font-size: 16px;
    font-weight: normal;
    flex-shrink: 1;
  `,
    CloseWrapper: styled.div `
    margin-left: auto;
    margin-bottom: auto;
    cursor: pointer;
  `,
};
export default FileUpload;
//# sourceMappingURL=FileUpload.styled.js.map